<template>
  <router-link
    :to="{
      name: 'settings.ai-history.show',
      params: { conversation_id: conversation.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Title:</span>
          <span class="strong">{{ conversation.title }}</span>
          <template v-if="conversation.context">
            <br />
            <span class="d-inline-block mt-1">
              <span class="text-capitalize">{{ conversation.context.type }}</span>:
              {{ conversation.context.name }}
            </span>
          </template>
        </p>
      </div>
      <div class="col-6 col-lg-3 col-xl-3">
        <p class="text-truncate">
          <span class="data-label d-lg-none">User:</span>
          {{ conversation.user_name }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Agent:</span>
          {{ conversation.agent }}
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <p>
          <span class="data-label d-lg-none">Messages:</span>
          {{ conversation.messages_count }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Updated:</span>
          {{ conversation.updated_at | moment("DD/MM/YYYY HH:mm") }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    conversation: {
      required: true,
      type: Object,
    },
  },
};
</script>
